import { selectBalancingMarketImprovements } from "../balancingSelectors/selectBalancingMarketImprovements";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { utilImprovements } from "../utils/utilImprovements";
import { selectOutskirtBuildingImprovementInfo } from "./selectOutskirtBuildingInfo";
export var selectMarketImprovementInfo = function (state) {
    var marketImprovementsInfo = selectBalancingMarketImprovements();
    var improvementItemsInfo = [];
    marketImprovementsInfo.forEach(function (improvementType) {
        if (improvementType.hideOnWeb) {
            return;
        }
        var improvement = selectOutskirtBuildingImprovementInfo(state, IdOutskirtBuildings.Market, improvementType.id);
        var level = improvement ? improvement.level || 0 : 0;
        var currentBonus = utilImprovements.selectBuffFromImprovementType(improvementType, level - 1);
        var nextBonus = utilImprovements.selectBuffFromImprovementType(improvementType, level);
        improvementItemsInfo.push({
            balancing: improvementType,
            currentBonus: currentBonus,
            icon: improvementType.icon,
            level: level,
            locaKey: improvementType.locaKeyDesc,
            nextBonus: nextBonus,
        });
    });
    return improvementItemsInfo;
};
export var selectMarketCurrentStage = function (state) {
    var market = state.contractInfo.market;
    if (market) {
        return market.stage;
    }
    return undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectMarketImprovementInfo.ts
// module id = 2709
// module chunks = 3